import { Component } from 'src/utils';
import template from './activate.html';
import resetPwdImg from './../../../images/reset-pass-2.png';
import confirmImg from './../../../images/tick-sent.png';


@Component({
  controllerAs: 'activate',
  template
})

export default class ActivateContainer {
  static $inject = [
    '$scope',
    '$stateParams',
    '$ngRedux',
    'authActions',
    'authService',
    '$window'
  ];

  constructor($scope, $stateParams, $ngRedux, authActions, authService,$window) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$ngRedux = $ngRedux;
    this.$stateParams = $stateParams;
    this.authActions = authActions;
    this.authService = authService;
    this.resetPwdImg = resetPwdImg;
    this.confirmImg = confirmImg;
    this.storeName = $stateParams.storeName;
    this.activate();
    this.$window = $window;
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      auth: state.auth
    };
  }

  activate() {
    this.authService.activate({
      id: this.$stateParams.id,
      token: this.$stateParams.token
    })
      .then(() => this.activationsuccess = true)
      .catch(err => {
        //  console.log(err);
        if (err.data.errorCode === 624 ) {
          this.alreadyUser = 'You have already successfully registered using this Activation.';
        }
        else {
          this.activationerror = err.data.message;
        }
      });
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
    this.activationerror = null;
    this.error = null;
    this.authService.resendEmail({
      id: this.$stateParams.id,
      email: this.email
    })
      .then(success => this.success = success.data.message)
      .catch(err => this.error = err.data.message);
  }
  login() {
    this.$window.location.href = '/'+this.storeName;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/activate/activate.js